import script from "./TheInquiry.vue?vue&type=script&setup=true&lang=js"
export * from "./TheInquiry.vue?vue&type=script&setup=true&lang=js"

import "./TheInquiry.vue?vue&type=style&index=0&id=0da2c818&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0da2c818"]])

export default __exports__